// src/pages/InnovationInfra.jsx
import React, { useState, useEffect } from "react";
import "./InnovationInfra.css";


// Import the images for Learning Spaces
import smartAcClass from "../assets/smart class.webp";
import digitalBoards from "../assets/display board.webp";
import aiRoboticsLab from "../assets/ai lab.webp";
import mathlab from "../assets/mathlab.webp";
import compositeLab from "../assets/composition.webp";
import library from "../assets/library.webp";
import recordingStudio from "../assets/recording-studio-image.jpeg";
import music from "../assets/music.webp";
import bhagavadgita from "../assets/prayer-image.JPG";



// ---------- Letter Reveal Component ----------
const LetterRevealText = ({
  text,
  className = "",
  speed = 18,
  trigger = false,
}) => {
  const [displayed, setDisplayed] = useState("");

  useEffect(() => {
    if (!trigger) return;

    setDisplayed("");
    if (!text) return;

    let i = 0;
    const interval = setInterval(() => {
      i += 1;
      setDisplayed(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, trigger]);

  return <p className={className}>{displayed}</p>;
};

// Learning Spaces Data
const learningSpaces = [
  {
    title: "SMART AC CLASSROOM",
    image: smartAcClass,
    desc:
      "At Vivek Vardhini Creative Minds School, our Smart AC Classrooms offer a spacious, comfortable, and learner-friendly environment. Each room is air-conditioned and equipped with ergonomic seating, ensuring students stay focused and learn in complete comfort. Designed for modern education, these classrooms create the ideal atmosphere for concentration, creativity, and academic excellence.",
  },
  {
    title: "DIGITAL BOARDS AND TABS",
    image: digitalBoards,
    desc:
      "Vivek Vardhini Creative Minds School stands at the forefront of modern education, where technology truly meets learning. Our classrooms are equipped with advanced digital boards that bring concepts to life through interactive visuals. Each student receives a personal learning tablet, enabling them to not just study but experience education in an engaging and immersive way. We integrate smart, AI-based assessments that offer instant feedback and personalised learning paths. These tablet-based tests make evaluation more accurate while keeping students motivated. By blending innovation with joyful learning, we ensure that every child stays curious, confident, and future-ready. At VV Creative Minds School, technology becomes a powerful tool to inspire young minds.",
  },
  {
    title: "AI & ROBOTICS LAB",
    image: aiRoboticsLab,
    desc:
      "Our state-of-the-art AI & Robotics Lab is designed to inspire young innovators by giving them hands-on experience with future-ready technologies. Equipped with advanced programmable robots, AI learning modules, sensors, microcontrollers, and interactive coding platforms, the lab allows students to design, build, and explore real-world automation. Every session blends creativity with scientific thinking, helping students apply classroom concepts through practical experimentation. Guided by trained mentors, students develop critical 21st-century skills such as problem-solving, logical reasoning, collaboration, and innovation. The lab also encourages participation in robotics challenges and tech competitions, ensuring our learners grow with confidence and curiosity in a safe, structured, and engaging environment.",
  },
  {
    title: "MATHS LAB",
    image: mathlab,
    desc:
      "The Maths Lab  at our school is a dedicated learning space designed to make math engaging, visual, and hands-on for students. Equipped with models, activity kits, geometric instruments, puzzles, and interactive teaching aids, the lab helps students explore mathematical ideas in a practical and meaningful way." +
      "Here, students learn by doing — experimenting with shapes, measuring objects, observing patterns, and solving problems through guided activities. This approach strengthens their conceptual understanding, builds logical and analytical thinking, and boosts confidence in the subject." +
      "By turning abstract concepts into real, tangible experiences, our Maths Lab encourages curiosity, creativity, and a deeper love for mathematics.",
  },
  {
    title: "COMPOSITE LAB",
    image: compositeLab,
    desc:
      "At Vivek Vardhini Creative Minds School, our Composite Science Laboratory is thoughtfully designed to give students a strong practical foundation in Physics, Chemistry, and Biology. The lab is equipped with essential scientific tools, models, charts, and experiment kits that help students explore core scientific concepts in a safe and engaging environment.Here, students conduct simple yet meaningful experiments, observe real scientific processes, and learn to record and interpret their findings. Each activity is structured to build curiosity, logical thinking, and problem-solving skills.",
  },
  {
    title: "LITERACY LOUNGE",
    image: library,
    desc:
      "At Vivek Vardhini Creative Minds School, our literacy lounge is not just a room filled with books—it’s a sanctuary of curiosity, imagination, and discovery. Here, students embark on journeys across time, cultures, and ideas, exploring subjects beyond the classroom. With carefully curated collections ranging from classic literature to cutting-edge research, digital resources, and interactive reading corners, the literacy lounge nurtures both academic excellence and creative thinking. More than a place to read, it’s a space where young minds cultivate critical thinking, self-learning, and a lifelong love for knowledge. Every visit promises inspiration, exploration, and the thrill of uncovering something new.",
  },
  {
    title: "RECORDING STUDIO",
    image: recordingStudio,
    desc:
      "Our state-of-the-art recording studio at Vivek Vardhini Creative Minds School is more than just a space with microphones and soundboards—it’s a hub where students’ ideas, music, and voices come alive. Designed to nurture creativity, technical skills, and self-expression, the studio allows students to experiment with audio production, podcasting, music recording, and voice-over projects. With professional-grade equipment and expert guidance, young creators can compose, edit, and produce their own work, gaining hands-on experience in modern audio technology. It’s a place where imagination meets innovation, andb every sound tells a story.",
  },
  {
    title: "MUSIC, DANCE & ARTS",
    image: music,
    desc:
      "At Vivek Vardhini Creative Minds School, the arts are at the heart of holistic education. Our Music, Dance, and Arts programs are designed to awaken imagination, nurture talent, and celebrate every child’s unique creative expression. From classical rhythms to contemporary beats, graceful movements to expressive drama, and vibrant visual arts to innovative crafts, students explore a spectrum of artistic experiences. These activities not only develop skills and confidence but also foster emotional intelligence, collaboration, and cultural appreciation. Here, creativity is not just taught—it’s experienced, performed, and cherished, making every student’s journey colorful, expressive, and memorable.",
  },
  {
    title: "BHAGAVAD GITA CLASSESS",
    image: bhagavadgita,
    desc:
      "At Vivek Vardhini Creative Minds School, The Bhagavad Gita classes are designed to promote holistic development by imparting ethical values, self-discipline, and clarity of thought among students. The program introduces age-appropriate concepts that encourage moral reasoning, emotional balance, and responsible decision-making. Through structured learning and guided discussions, students gain insights into duty, integrity, compassion, and perseverance. The teachings are presented in an inclusive and educational manner, focusing on life skills rather than religious instruction. These classes support character building and personal growth alongside academic excellence.",
  },
];



const InnovationInfra = () => {
  //const heroRef = useRef(null);
  const [visibleRows, setVisibleRows] = useState({});



  // Observe each learning row for text reveal
  useEffect(() => {
    const rows = document.querySelectorAll(".learning-space-row");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const idxAttr = entry.target.getAttribute("data-index");
          if (!idxAttr) return;

          const idx = parseInt(idxAttr, 10);
          if (entry.isIntersecting) {
            setVisibleRows((prev) => {
              if (prev[idx]) return prev;
              return { ...prev, [idx]: true };
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25 }
    );

    rows.forEach((row) => observer.observe(row));

    return () => observer.disconnect();
  }, []);

  // NEW IMAGE INTERSECTION OBSERVER (SCROLL REVEAL IMAGES)
  useEffect(() => {
    const imgs = document.querySelectorAll(".ls-img");

    const imgObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ls-img--show");
            imgObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );

    imgs.forEach((img) => imgObserver.observe(img));

    return () => imgObserver.disconnect();
  }, []);

  return (
    <div className="section alt innovation-section" data-aos="fade-up">
      {/* TOP HEADINGS */}
      <h2 className="section-title reveal-text infra-main-heading">
        Innovation &amp; Infrastructure
      </h2>

      {/* LEARNING SPACES */}
      <section className="learning-spaces-section">
        <h2 className="learning-spaces-title">Learning Spaces</h2>

        <div className="learning-spaces-grid">
          {learningSpaces.map((item, index) => (
            <div
              className="learning-space-row"
              key={index}
              data-index={index}
              data-aos="fade-up"
              data-aos-offset="140"
            >
              {index % 2 === 0 ? (
                <div className="learning-space-item">
                  <div className="learning-space-left">
                    <h3>{item.title}</h3>
                    <img
                      src={item.image}
                      alt={item.title}
                      className="ls-img"
                    />
                  </div>
                  <div className="learning-space-right">
                    <LetterRevealText
                      text={item.desc}
                      className="learning-space-desc"
                      speed={16}
                      trigger={!!visibleRows[index]}
                    />
                  </div>
                </div>
              ) : (
                <div className="learning-space-item">
                  <div className="learning-space-left">
                    <LetterRevealText
                      text={item.desc}
                      className="learning-space-desc"
                      speed={16}
                      trigger={!!visibleRows[index]}
                    />
                  </div>
                  <div className="learning-space-right">
                    <h3>{item.title}</h3>
                    <img
                      src={item.image}
                      alt={item.title}
                      className="ls-img"
                    />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>


    </div>
  );
};

export default InnovationInfra;
